<template>
  <div class="col" style="margin-bottom: 1%">
    <div class="col-6">
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" v-model="pergunta" id="pergunta" placeholder="Escreva a PERGUNTA aqui..." required />
      </div>
    </div>
    <div class="col-6" style="margin-top: 1%">
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" v-model="resposta" id="resposta" placeholder="Escreva a RESPOSTA aqui..." required />
      </div>
    </div>
  </div>
  <button type="button" class="btn btn-primary" style="display: block; margin: 0 auto; width: 10%" @click="salvar">SALVAR</button>
  <div style="margin-top: 5px">
    <a-table :dataSource="listaPerguntaResposta" :columns="columns">
      <template #data="{ record }">
        <span>{{ stringData(record) }}</span>
      </template>
      <template #action="{ record }">
        <a @click="excluir(record)" alt="Excluir"> <i class="fas fa-trash-can icon-trash-can"></i></a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { createPergunta, deletePergunta, getPerguntaByIdRegistroAtendimento } from '@/components/service/perguntasRespostas';
import { openNotification, typesNotification } from '@/utils/notifications';
import moment from 'moment';
import { getByIdRegistroAtendimento } from '@/components/service/registroAtendimentoService';

export default {
  name: 'AtendimentoPergunta',
  data() {
    return {
      fields: [],
      listaPerguntaResposta: [],
      pergunta: '',
      resposta: '',
      columns: [
        {
          title: 'Pergunta',
          dataIndex: 'pergunta',
          key: 'pergunta',
          slots: { customRender: 'pergunta' },
        },
        {
          title: 'Resposta',
          dataIndex: 'resposta',
          key: 'resposta',
          slots: { customRender: 'resposta' },
        },
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: { customRender: 'data' },
        },
        {
          title: 'Ação',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    this.idRegistroAtendimento = this.$route.query.id;
    await this.getPergunta();
  },
  methods: {
    async getPergunta() {
      await getPerguntaByIdRegistroAtendimento(this.idRegistroAtendimento).then((esp) => {
        this.listaPerguntaResposta = esp.data.reverse();
      });
    },
    async salvar() {
      if (!this.pergunta || !this.resposta) {
        openNotification(typesNotification.error, 'Por favor, preencha todos os campos obrigatórios.');
        return;
      }
      await createPergunta(await this.monterObjeto()).then(() => {
        this.fields = [];
        this.getPergunta();
        openNotification(typesNotification.success, 'Salvo com sucesso.');
      });
    },
    async monterObjeto() {
      let perguntaResposta = {};
      let registroAtendimento = {};
      let idRegistroAtendimento = this.idRegistroAtendimento;
      await getByIdRegistroAtendimento(idRegistroAtendimento).then((p) => {
        registroAtendimento = p.data;
      });
      perguntaResposta.resposta = this.resposta;
      perguntaResposta.pergunta = this.pergunta;
      perguntaResposta.registroAtendimento = registroAtendimento;
      perguntaResposta.data = new Date();

      return perguntaResposta;
    },

    async excluir(obj) {
      await deletePergunta(obj.id).then(() => {
        this.getPergunta();
        openNotification(typesNotification.success, 'Exclusão efetuada com sucesso!');
      });
    },

    stringData(record) {
      return moment(record.data).format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>

<style scoped></style>
